import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type LinkItemLocationToEventAccountMutationVariables = Types.Exact<{
  event_account_id: Types.Scalars['ID'];
  item_location_id: Types.Scalars['ID'];
}>;


export type LinkItemLocationToEventAccountMutation = { __typename?: 'Mutation', linkItemLocationToEventAccount: { __typename?: 'ItemLocation', id: string } };


export const LinkItemLocationToEventAccountDocument = gql`
    mutation linkItemLocationToEventAccount($event_account_id: ID!, $item_location_id: ID!) {
  linkItemLocationToEventAccount(
    event_account_id: $event_account_id
    item_location_id: $item_location_id
  ) {
    id
  }
}
    `;
export type LinkItemLocationToEventAccountMutationFn = Apollo.MutationFunction<LinkItemLocationToEventAccountMutation, LinkItemLocationToEventAccountMutationVariables>;

/**
 * __useLinkItemLocationToEventAccountMutation__
 *
 * To run a mutation, you first call `useLinkItemLocationToEventAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkItemLocationToEventAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkItemLocationToEventAccountMutation, { data, loading, error }] = useLinkItemLocationToEventAccountMutation({
 *   variables: {
 *      event_account_id: // value for 'event_account_id'
 *      item_location_id: // value for 'item_location_id'
 *   },
 * });
 */
export function useLinkItemLocationToEventAccountMutation(baseOptions?: Apollo.MutationHookOptions<LinkItemLocationToEventAccountMutation, LinkItemLocationToEventAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkItemLocationToEventAccountMutation, LinkItemLocationToEventAccountMutationVariables>(LinkItemLocationToEventAccountDocument, options);
      }
export type LinkItemLocationToEventAccountMutationHookResult = ReturnType<typeof useLinkItemLocationToEventAccountMutation>;
export type LinkItemLocationToEventAccountMutationResult = Apollo.MutationResult<LinkItemLocationToEventAccountMutation>;
export type LinkItemLocationToEventAccountMutationOptions = Apollo.BaseMutationOptions<LinkItemLocationToEventAccountMutation, LinkItemLocationToEventAccountMutationVariables>;